"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDynamicTableColumns = exports.applyPageSize = exports.applyRowSize = exports.applyTableSort = exports.applyTableSearch = exports.applyTableColumnWidth = exports.applyTableFilter = void 0;
const reducers_1 = require("./reducers");
const utils_1 = require("../../../hooks/product-table-dynamic-columns/utils");
// Table operations
// RTK-slice friendly pure functions to apply changes to TableState
const applyTableFilter = (state, filter) => (Object.assign(Object.assign({}, state), { filter }));
exports.applyTableFilter = applyTableFilter;
const applyTableColumnWidth = (state, columnWidth) => (Object.assign(Object.assign({}, state), { columnWidth }));
exports.applyTableColumnWidth = applyTableColumnWidth;
const applyTableSearch = (state, search) => (Object.assign(Object.assign({}, state), { search }));
exports.applyTableSearch = applyTableSearch;
const applyTableSort = (state, sort) => (Object.assign(Object.assign({}, state), { sort }));
exports.applyTableSort = applyTableSort;
const applyRowSize = (state, rowSize) => (Object.assign(Object.assign({}, state), { rowSize }));
exports.applyRowSize = applyRowSize;
const applyPageSize = (state, pageSize) => (Object.assign(Object.assign({}, state), { pageSize: pageSize !== null && pageSize !== void 0 ? pageSize : state.pageSize }));
exports.applyPageSize = applyPageSize;
const applyDynamicTableColumns = (state, changes) => {
    var _a, _b;
    const newDynamicColumns = Object.assign(Object.assign(Object.assign({}, reducers_1.defaultTableState.dynamicColumns), state.dynamicColumns), changes);
    const newFilter = Object.assign(Object.assign({}, state.filter), { items: ((_b = (_a = state.filter) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []).filter((item) => (0, utils_1.checkIsColumnSelected)(item.field, newDynamicColumns)) });
    return Object.assign(Object.assign({}, state), { dynamicColumns: newDynamicColumns, filter: newFilter });
};
exports.applyDynamicTableColumns = applyDynamicTableColumns;
